import React, { useState } from "react";
import "../assets/css/recruiters.css";
import { recruiters } from "../assets/data/recruiters";

function Recruiters() {
    return (
        <section className="recruiters-section">
            <div className="container mx-auto">
                <div className="flex flex-row justify-between">
                    <div className="w-fit">
                        <div className="section-eyebrow">
                            <span></span>
                            TOP RECRUITERS
                        </div>

                        <h2>
                            Trusted by
                            <em> Leading Employers</em>
                        </h2>
                    </div>
                    <div className="w-fit">
                        <a href="/placements" className="placement-btn ms-auto">
                            Explore Placements →
                        </a>
                    </div>
                </div>

                <p>
                    ISBM University has built strong industry partnerships with
                    leading national and multinational organizations. Through
                    campus recruitment drives, internships, live projects and
                    career development programmes, students receive exceptional
                    opportunities to begin successful professional careers.
                </p>

                <div className="recruiter-grid">

                    {recruiters.map((logo, index) => (

                        <div className="recruiter-item" key={index}>

                            <img src={logo} alt="Recruiter" />

                        </div>

                    ))}

                </div>

            </div>
        </section>
    );
}

export default Recruiters;

